export default {
    data() {
        return {
            emptyStateData: {
                title: this.$t.__('email.listings.linkObjectDialog.empty_state_title'),
                caption: this.$t.__('email.listings.linkObjectDialog.empty_state_caption'),
                illustrationPath: '/ressources/logged/img/illustrations/empty-activities.svg',
            },
        };
    },
    methods: {
        formatRelatedObjects(relatedObjects) {
            return relatedObjects.map((relatedObject) => ({
                data: relatedObject,
                blockType: relatedObject.type,
            }));
        },
        formatAndSimplifyRelatedObjects(relatedObjects) {
            return relatedObjects.map((relatedObject) => this.simplifyRelatedObject(relatedObject));
        },
        simplifyRelatedObject(relatedObject) {
            if (relatedObject.data.object) {
                return {
                    id: relatedObject.data.object.id,
                    type: relatedObject.data.object.sub_type,
                };
            }

            return {
                id: relatedObject.data.id,
                type: relatedObject.data.type,
            };
        },
        mergeRelatedObjects(relatedObject1, relatedObjects2) {
            const newRelatedObjects = [...relatedObject1];
            for (const relatedObject of relatedObjects2) {
                if (
                    !newRelatedObjects.some((newRelatedObject) =>
                        this.isSameRelatedObjects(newRelatedObject, relatedObject),
                    )
                ) {
                    newRelatedObjects.push(relatedObject);
                }
            }
            return newRelatedObjects;
        },
        isSameRelatedObjects(relatedObject1, relatedObject2) {
            const relatedObject1Formatted = this.simplifyRelatedObject(relatedObject1);
            const relatedObject2Formatted = this.simplifyRelatedObject(relatedObject2);
            return (
                relatedObject1Formatted.id === relatedObject2Formatted.id &&
                relatedObject1Formatted.type === relatedObject2Formatted.type
            );
        },
    },
};
